var $ = require('jquery');
import 'jquery-touchswipe';
"use strict";

var PLUGIN_NAME = "productListSlider";

var DEFAULTS = {
	containerOuterWidth: true
};

// The actual plugin constructor
function ProductListSlider(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this.$me = $(this.element);

	this.windowWidth = $(window).width();

	this.data = {};

	this.initialise();
}

/**
 * init
 */
ProductListSlider.prototype.initialise = function() {
	var self = this;

	self.data.$container = self.$me.parents('.product-list-slider-container > div');
	self.data.$sliderItems = self.$me.children('li');
	self.data.firstVisibleItemIndex = 0;
	self.data.pageIndex = 0;

	self.buildHtml();
	self.updateContainerWidth();
	self.updateFirstVisibleItem();
	self.bindEvents();
};

ProductListSlider.prototype.updateContainerWidth = function() {
	var self = this,
		sliderItemWidth;

	self.$me.removeAttr('style');
	self.data.$sliderItems.removeAttr('style');
	sliderItemWidth = self.data.$sliderItems.filter(':first').outerWidth();
	self.data.$sliderItems.css('width', sliderItemWidth);
	self.$me.css('width',sliderItemWidth * self.data.$sliderItems.length);
	self.showNav();
};

ProductListSlider.prototype.buildHtml = function() {
	var self = this;

	// arrows
	self.data.$prevBtn = $('<a class="widget-controls__item widget-controls__item--prev item-slider__arrow item-slider__arrow--prev prev" href="javascript:" data-dir="prev"><span class="widget-controls__ico ico"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#arrow"></use></svg></span></a>');
	self.data.$nextBtn = $('<a class="widget-controls__item widget-controls__item--next item-slider__arrow item-slider__arrow--next next" href="javascript:" data-dir="next"><span class="widget-controls__ico ico"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#arrow"></use></svg></span></a>');
	self.data.$btnContainer = $('<p class="widget-controls item-slider__arrows nav-controls"></p>').append(self.data.$prevBtn).append(self.data.$nextBtn);
	self.$me.after(self.data.$btnContainer);

	// bullets
  self.data.$bulletsContainer = $('<p class="widget-bullets item-slider__bullets"></p>');
  self.$me.after(self.data.$bulletsContainer);
};

ProductListSlider.prototype.bindEvents = function() {
	var self = this;

	$(window).on('resize', function() {
	  //zohlednit pouze zmenu sirky, zmena vysky se deje na mobilech pri scrollu
    if ($(this).width() != self.windowWidth) {
      self.windowWidth = $(this).width();
      self.data.firstVisibleItemIndex = 0;
      self.data.pageIndex = 0;
      self.updateContainerWidth();
      self.skipToSlide(false);
      self.updateFirstVisibleItem();
    }
	});
	window.addEventListener('orientationchange', function () {
	  self.data.firstVisibleItemIndex = 0;
		self.updateContainerWidth();
		self.skipToSlide(false);
		self.updateFirstVisibleItem();
	}, false);

	self.data.$prevBtn.on('click', function(e){
		self.slide(-1);
		e.preventDefault();
	});
	self.data.$nextBtn.on('click', function(e){
		self.slide(+1);
		e.preventDefault();
	});

	self.data.$bulletsContainer.on('click', 'a', function(e){
    self.skipToPage($(this));
    e.preventDefault();
  });

	self.$me.swipe({
		swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
			if (direction == 'left') {
				self.slide(+1);
			}
			if (direction == 'right') {
				self.slide(-1);
			}
		},
    allowPageScroll: 'vertical',
		excludedElements: 'form, button, input, select, textarea, .noSwipe',
	});
};

ProductListSlider.prototype.showNav = function() {
	var self = this;

	if ((self.$me.outerWidth() > self.data.$container.outerWidth()) || (self.data.firstVisibleItemIndex != 0)) {
		self.data.$btnContainer.removeClass('hidden');
		self.updateButtonsState();
	}
	else {
		self.data.$btnContainer.addClass('hidden');
	}
};

ProductListSlider.prototype.slide = function(direction) {
	var self = this,
		items = self.data.$sliderItems.length,
		itemWidth = self.data.$sliderItems.outerWidth(true),
		containerWidth = self.data.$container.outerWidth(self.options.containerOuterWidth),
		visibleItemsCount = Math.round(containerWidth / itemWidth),
		newPosition = self.data.firstVisibleItemIndex + (direction * visibleItemsCount),
    newPage = self.data.pageIndex + (direction);

	if (newPosition > (items - visibleItemsCount)) {
		newPosition = items - visibleItemsCount;
	}

	if (newPage > self.data.pages - 1) {
	  newPage = self.data.pages - 1;
  }

	if (newPosition < 0) {
		newPosition = 0;
		newPage = 0;
	}

	self.data.firstVisibleItemIndex = newPosition;
	self.data.pageIndex = newPage;

	self.skipToSlide(true);

	self.updateFirstVisibleItem();
};

ProductListSlider.prototype.updateFirstVisibleItem = function() {
	var self = this;
	self.data.$sliderItems.removeClass('first-visible-item');
	self.data.$sliderItems.eq(self.data.firstVisibleItemIndex).addClass('first-visible-item')
}


ProductListSlider.prototype.skipToSlide = function(animate) {
	var self = this,
			itemWidth = self.data.$sliderItems.outerWidth(true),
			marginLeft = -(itemWidth * self.data.firstVisibleItemIndex);

	if (animate) {
		self.data.$btnContainer.addClass('hidden');
		self.$me.animate({
			'marginLeft': marginLeft
		}, 500, function() {
			self.data.$btnContainer.removeClass('hidden');
			self.updateButtonsState();
		});
	}
	else {
		self.$me.css('margin-left', marginLeft);
		self.updateButtonsState();
	}
};

ProductListSlider.prototype.skipToPage = function(page) {
  var self = this,
      targetPage = page.data('index');

  if (targetPage != self.data.pageIndex) {
    self.slide(targetPage - self.data.pageIndex);
  }
}

ProductListSlider.prototype.updateButtonsState = function() {
	var self = this,
		items = self.data.$sliderItems.length,
		itemWidth = self.data.$sliderItems.outerWidth(true),
		containerWidth = self.data.$container.outerWidth(self.options.containerOuterWidth),
		visibleItemsCount = Math.round(containerWidth / itemWidth);
	  self.data.pages = (Math.ceil(items / visibleItemsCount));


	if (self.data.firstVisibleItemIndex == 0) {
		self.data.$prevBtn.addClass('disabled');
	}
	else {
		self.data.$prevBtn.removeClass('disabled');
	}

	if ((self.data.firstVisibleItemIndex + visibleItemsCount) > (items - 1)) {
		self.data.$nextBtn.addClass('disabled');
	}
	else {
		self.data.$nextBtn.removeClass('disabled');
	}

	if ((self.data.firstVisibleItemIndex == 0) && ((self.data.firstVisibleItemIndex + visibleItemsCount) > (items - 1))) {
		self.$me.css('margin-left', null);
	}

	self.updateBullets();
};


ProductListSlider.prototype.updateBullets = function() {
  var self = this,
      activeClass;

  self.data.$bulletsContainer.empty();

  if (self.data.pages > 1) {
    for (var i = 0; i < self.data.pages; i++) {
      if (i == self.data.pageIndex) {
        activeClass = ' widget-bullets__item--active';
      }
      else {
        activeClass = '';
      }

      self.data.$bulletsContainer.append('<a href="javascript:" class="widget-bullets__item' + activeClass + '" data-index="' + i + '">' + i + '</a>')
    }
  }
}

/**
 * decide, which methods will be "public"
 */
var API = {
	//action: ProductListSlider.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new ProductListSlider(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.product-list-slider.js